// material-ui

// ==============================|| LOADER ||============================== //
const SuspenseComponentLoader = () => <div>Loading...</div>;

export default SuspenseComponentLoader;
